import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  State,
  getWebsites,
  getWebsitesAction,
  getIsWebsitesLoading,
} from '../../store';
import { map, debounceTime } from 'rxjs/operators';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ecom-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  constructor(
    private readonly store: Store<State>,
    private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}
  searchQuery$ = new BehaviorSubject<string>(null);
  isLoading$ = this.store.pipe(select(getIsWebsitesLoading));
  websites$ = combineLatest([
    this.store.pipe(select(getWebsites)),
    this.searchQuery$,
  ]).pipe(
    debounceTime(100),
    map(([websites, searchQuery]) => {
      const formattedQuery =
        searchQuery != null ? searchQuery.trim().toLowerCase() : '';
      if (formattedQuery) {
        return websites.filter((website) => {
          const includes = website.accountId.includes(formattedQuery);
          return includes;
        });
      } else {
        return websites;
      }
    }),
    map((websites) =>
      websites
        .slice()
        .sort((a, b) =>
          a.accountId.toLowerCase() < b.accountId.toLowerCase()
            ? -1
            : a.accountId.toLowerCase() > b.accountId.toLowerCase()
            ? 1
            : 0,
        ),
    ),
  );

  onSearch(value: string) {
    this.searchQuery$.next(value);
  }

  ngOnInit() {
    this.store.dispatch(getWebsitesAction());
  }

  copyToClipboard = (str: string, event: MouseEvent) => {
    event.preventDefault();
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.toastr.info(`"${str}"`, 'Copied to clipboard');
  };

  editWebsite(websiteId: string) {
    this.router.navigate([`websites/${websiteId}`], {
      relativeTo: this.route,
    });
  }

  addWebsite() {
    this.router.navigate([`websites/add`], {
      relativeTo: this.route,
    });
  }
}
